import {
  Box,
  Container,
  Heading,
  Flex,
  FormLabel,
  FormControl,
  Input,
  Button,
  Card,
  CardBody,
  Checkbox,
  Tooltip,
  IconButton,
  Text,
  Select,
} from "@chakra-ui/react";
// As chamadas de serviço reais foram comentadas, pois usaremos os mocks
// import {
//   cleanBalanceSolicitation,
//   getBalanceSolicitationsV2,
// } from "@/services/balanceSolicitation.service";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo, useState } from "react";
import { statusInfoMap } from "@/utils/balanceSolicitationStatusMapper";
import CustomSelectComponent from "../../CustomSelectComponent/CustomSelectComponent";
import InputMask from "react-input-mask";
import { FaListUl } from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";
import { FaTh } from "react-icons/fa";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { debounce } from "lodash";
import ConsignadoConsultCpfInputCard from "../ConsignadoConsultCpfInputCard";
import { cleanConsignadoBalanceSolicitation, getConsignadoBalanceSolicitations } from "@/services/consignado/balanceSolicitation.service";
import ConsignadoBalanceSolicitationResultCards from "../ConsignadoBalanceSolicitationResultCards";
import ConsignadoBalanceSolicitationResultTable from "../ConsignadoBalanceSolicitationResultTable";
import ConsignadoProcessingQueueSummary from "../ConsignadoProcessingQueueSummary";
import { useConditionalBackground } from "@/contexts/useConditionalBackground";
import { MdOutlineList } from "react-icons/md";

export type FilterFields = "cpf" | "data" | "status";

type TabValue = "consulta" | "processamento";

interface Tab {
  label: string;
  value: TabValue;
}

export default function ConsignadoSimulationPage() {
  const backgroundStyle = useConditionalBackground();
  const [activeTab, setActiveTab] = useState<TabValue>("consulta");

  const tabs: Tab[] = [
    { label: "FILA DE CONSULTA", value: "consulta" },
    { label: "FILA DE PROCESSAMENTO", value: "processamento" },
  ];

  const [filterBy, setFilterBy] = useState<FilterFields>("cpf");
  const [filterValue, setFilterValue] = useState("");
  const [debouncedFilterValue, setDebouncedFilterValue] = useState("");
//   const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [selectedView, setSelectedView] = useState<"grid" | "list">("grid");
  const [isAllSelected, setIsAllSelected] = useState(false);
//   const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  const debouncedSetFilter = useMemo(
    () =>
      debounce((value: string) => {
        setDebouncedFilterValue(value);
        setPage(1); // Reseta para a primeira página ao aplicar filtro
      }, 1500),
    []
  );
  const statusOptions = Array.from(
    new Set(Object.values(statusInfoMap).map((statusInfo) => statusInfo.label))
  ).map((label) => ({
    value: label,
    label: label,
  }));

  const filterOptions = [
    { value: "", label: "Escolha um Filtro" },
    { value: "cpf", label: "CPF" },
    { value: "status", label: "Status" },
//     { value: "createdAt", label: "Data" },
  ];

//   const fetchConsults = async () => {
//     return await getConsignadoBalanceSolicitations({
//       page,
//       pageSize,
//       filterBy,
//       filterValue: debouncedFilterValue,
//     });
//   };

  const {
    data: documentConsult,
    refetch,
    isLoading,
    isRefetching,
  } = useQuery({
    queryKey: ["cpfConsults", page, pageSize, debouncedFilterValue, filterBy],
    queryFn: () => getConsignadoBalanceSolicitations({
      page,
      pageSize,
      filterBy,
      filterValue: debouncedFilterValue
    }),
    refetchOnWindowFocus: false,
    enabled:
      filterBy !== "cpf" ||
      debouncedFilterValue.length >= 11 ||
      debouncedFilterValue === "",
    staleTime: 13 * 1000,
    refetchInterval: 13 * 1000,
    placeholderData: (prev) => prev,
  });

  const handleFilterValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setFilterValue(value);

    if (filterBy === "cpf") {
      debouncedSetFilter(value.replace(/[^\d]/g, ""));
    } else {
      setDebouncedFilterValue(value);
      setPage(1);
    }
  };

  const handleFilterByChange = (selectedOption: any) => {
    const newFilterBy = selectedOption?.value as FilterFields;
    setFilterValue("");
    setDebouncedFilterValue("");
    setFilterBy(newFilterBy);
    debouncedSetFilter.cancel(); 
  };

  useEffect(() => {
    return () => debouncedSetFilter.cancel();
  }, [debouncedSetFilter]);

  const totalPages = documentConsult?.totalPages || 1;

  useEffect(() => {
    // Desmarcar "Marcar Todos" se a lista de IDs mudar (ex: paginação)
    if (selectedIds.length > 0 && selectedIds.length !== documentConsult?.data?.length) {
        setIsAllSelected(false);
    }

    if (isAllSelected) {
      const allIds = documentConsult?.data
        .map((item) => item.id)
        .filter((id): id is string => id !== undefined);
      setSelectedIds(allIds ?? []);
    } else {
      if(selectedIds.length === documentConsult?.data?.length && documentConsult?.data?.length > 0){
        setSelectedIds([]);
      }
    }
  }, [isAllSelected, documentConsult?.data]);

//   const handleDateChange = (dates: [Date | null, Date | null]) => {
//     setDateRange(dates);
//     const [start, end] = dates;

//     if (start && end) {
//       const formattedStart = start.toLocaleDateString("pt-BR");
//       const formattedEnd = end.toLocaleDateString("pt-BR");
//       const finalValue = `${formattedStart} - ${formattedEnd}`;
//       setFilterValue(finalValue);
//       setDebouncedFilterValue(finalValue);
//       setPage(1);
//       setShowDatePicker(false);
//     } else {
//       setFilterValue("");
//       setDebouncedFilterValue("");
//     }
//   };

  const getInputProps = () => {
    switch (filterBy) {
      case "cpf":
        return {
          as: InputMask,
          mask: "999.999.999-99",
          maskChar: null,
          placeholder: "000.000.000-00",
        };
//       case "createdAt":
//         return {
//           placeholder: "Selecione um período",
//           onFocus: () => setShowDatePicker(true),
//           readOnly: true, // Para forçar o uso do DatePicker
//         };
      case "status":
        return null;
    }
  };

  const handleRefetch = () => {
    setPage(1);
    setPageSize(10);
    setFilterValue("");
    setDebouncedFilterValue("");
    setFilterBy("cpf");
    refetch();
  };

  const handlePageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPageSize(Number(e.target.value));
    setPage(1);
  };

  const handleStatusChange = (selectedOption: any) => {
    const value = selectedOption?.value || "";
    setFilterValue(value);
    setDebouncedFilterValue(value); 
    setPage(1);
  };

  return (
    <Container maxW="full" padding={{ base: "2", md: "4" }}>
      <Box width="100%" minW="0" pb={4}>
        <Box
          {...backgroundStyle}
          borderRadius="md"
          p={{ base: "4", md: "6" }}
          color="white"
          boxShadow="md"
          width="100%"
          mb={6}
        >
          <Box
            alignItems={{ base: "center", md: "center" }}
            flexDirection={{ base: "column", md: "row" }}
            textAlign={{ base: "center", md: "left" }}
          >
            <Flex
              alignItems="center"
              mb={{ base: "4", md: "-10" }}
              maxW={{ base: "100%", md: "80%", lg: "70%" }}
            >
              <MdOutlineList size="2rem" />
              <Text
                fontSize={{ base: "2xl", md: "4xl" }}
                fontWeight="bold"
                ml={2}
                fontFamily="Lexend Deca"
              >
                Consulta de CPF
              </Text>
            </Flex>
            <Flex
              gap={{ base: 4, md: 6, lg: 8 }}
              justify="center"
              wrap="wrap"
              mx="auto"
              w="100%"
              maxW={{ base: "100%", md: "80%", lg: "70%" }}
            >
              {tabs.map((tab: Tab) => (
                <Box
                  key={tab.value}
                  textAlign="center"
                  position="relative"
                  cursor="pointer"
                  onClick={() => setActiveTab(tab.value)}
                  mb={{ base: 2, md: 0 }}
                >
                  <Text
                    fontSize={{ base: "lg", md: "xl", lg: "2xl" }}
                    fontWeight="bold"
                    color={activeTab === tab.value ? "white" : "whiteAlpha.800"}
                    transition="color 0.3s ease"
                    fontFamily="Lexend Deca"
                  >
                    {tab.label}
                  </Text>
                  {activeTab === tab.value && (
                    <Box
                      position="absolute"
                      bottom="-4px"
                      left="50%"
                      transform="translateX(-50%)"
                      height="4px"
                      width="40px"
                      bgColor="white"
                      transition="width 0.3s ease, background-color 0.3s ease"
                    />
                  )}
                </Box>
              ))}
            </Flex>
          </Box>
        </Box>

        {activeTab === "consulta" && (
      <Flex direction="column" gap={{ base: 4, md: 8 }} w={"100%"} alignItems="center">
        <ConsignadoConsultCpfInputCard />
        <Card shadow="md" borderRadius="md" minWidth="347px" width={"100%"} minH="100vh">
          <CardBody>
            <Flex
              direction="column"
              mb={4}
            >
  
              <Heading
                size="md"
                mb={4}
                color="gray.500"
                fontFamily="Lexend Deca"
                fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
              >
                Fila de consulta
              </Heading>

              <Flex
                gap={4}
                alignItems="flex-start"
                flexWrap="wrap"
                justifyContent="space-between"
               >
                <Flex direction="column" gap={2} flex="1" minW="300px">
                  <FormControl display="flex" alignItems="center" mb={4}>
                    <FormLabel mb="0" mr={2} color="gray.500" fontFamily="Lexend Deca">
                      Filtrar por:
                    </FormLabel>
                    <CustomSelectComponent
                      options={filterOptions}
                      value={
                        filterOptions.find((option) => option.value === filterBy) ||
                        filterOptions[0]
                      }
                      onChange={handleFilterByChange}
                      fontFamily="Lexend Deca"
                    />
                  </FormControl>
                  <FormControl display="flex" alignItems="center">
                    <FormLabel mb="0" mr={2} color="gray.500" fontFamily="Lexend Deca" whiteSpace="nowrap">
                      {filterBy === "cpf"
                        ? "Pesquisar CPF:"
                        : "Pesquisar Status:"}
                    </FormLabel>

                    {filterBy === "status" ? (
                      <CustomSelectComponent
                        options={statusOptions}
                        value={
                          statusOptions.find((option) => option.value === filterValue) ||
                          null
                        }
                        onChange={handleStatusChange}
                        placeholder="Escolha um Status"
                        fontFamily="Lexend Deca"
                      />
                    ) : (
                      <Box position="relative">
                        <Input
                          {...getInputProps()}
                          fontFamily="Lexend Deca"
                          value={filterValue}
                          type="tel"
                          onChange={handleFilterValueChange}
                          width={{ base: "100%", md: "200px" }}
                        />
{/*                         {filterBy === "createdAt" && showDatePicker && (
                          <Box
                            position="absolute"
                            zIndex="dropdown"
                            bg="white"
                            border="1px solid #ddd"
                            borderRadius="md"
                            boxShadow="lg"
                            mt={1}
                          >
                            <DatePicker
                              selected={dateRange[0] || undefined}
                              onChange={handleDateChange}
                              startDate={dateRange[0] || undefined}
                              endDate={dateRange[1] || undefined}
                              selectsRange
                              inline
                              dateFormat="dd/MM/yyyy"
                              onClickOutside={() => setShowDatePicker(false)}
                              placeholderText="Selecione o período"
                            />
                          </Box>
                        )} */}
                      </Box>
                    )}
                  </FormControl>

                
                </Flex>

                <Flex gap={4} alignItems={"flex-start"}>
                  <Flex direction="column">
                    <Button
                      colorScheme="secondary"
                      color="white"
                      onClick={handleRefetch}
                      isDisabled={isLoading || isRefetching}
                      isLoading={isLoading || isRefetching}
                      fontFamily="Lexend Deca"
                      mb={2}
                      loadingText="Recarregando"
                    >
                      Recarregar
                    </Button>
                    <Button
                      onClick={async () => {
                        try {
                            // AQUI USAMOS A NOSSA FUNÇÃO DE LIMPEZA MOCKADA
                          await cleanConsignadoBalanceSolicitation(selectedIds);
                          setSelectedIds([]);
                          setIsAllSelected(false);
                          refetch();
                        } catch (error) {
                          console.error("Erro ao limpar as consultas:", error);
                        }
                      }}
                      colorScheme="red"
                      color="white"
                      borderRadius="md"
                      isDisabled={selectedIds.length === 0}
                      fontFamily="Lexend Deca"
                      mb={2}
                    >
                      Limpar Consulta
                    </Button>
                    <Checkbox
                      isChecked={isAllSelected}
                      onChange={(e) => setIsAllSelected(e.target.checked)}
                      colorScheme="blue"
                      fontFamily="Lexend Deca"
                    >
                      Marcar Todos
                    </Checkbox>
                    <Flex justifyContent="center" gap={2} mt={2}>
                      <Tooltip label="Visualização em Cards" placement="top">
                        <IconButton
                          icon={<FaTh size="1em" />}
                          aria-label="Grid View"
                          onClick={() => setSelectedView("grid")}
                          isActive={selectedView === "grid"}
                        />
                      </Tooltip>
                      <Tooltip label="Visualização em Tabela" placement="top">
                        <IconButton
                          icon={<FaListUl size="1em" />}
                          aria-label="List View"
                          onClick={() => setSelectedView("list")}
                          isActive={selectedView === "list"}
                        />
                      </Tooltip>
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>

            <Box
              fontFamily="Lexend Deca"
              w="full"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              mt={4}
            >
              {isLoading && <Text>Carregando consultas...</Text>}
              {documentConsult?.data?.length === 0 && !isLoading &&  (
                <Heading mt={20} textAlign={"center"} color="gray.600">
                  Nenhuma Proposta Encontrada
                </Heading>
              )}

              {documentConsult?.data && documentConsult.data.length > 0 && (
                <>
                <Flex justifyContent="center" mt={2} mb={5} alignItems="center" flexWrap="wrap" gap={2}>
                      <IconButton
                        icon={<ChevronLeftIcon />}
                        onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                        isDisabled={page === 1}
                        aria-label="Página Anterior"
                      />
                      <Text mx={4}>
                        Página {page} de {totalPages}
                      </Text>
                      <IconButton
                        icon={<ChevronRightIcon />}
                        onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
                        isDisabled={page === totalPages}
                        aria-label="Próxima Página"
                      />
                      <Flex alignItems="center" ml={4}>
                        <Text mr={2}>Itens por página:</Text>
                        <Select
                          value={pageSize}
                          onChange={handlePageSizeChange}
                          width="fit-content"
                        >
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                          <option value={50}>50</option>
                        </Select>
                      </Flex>
                </Flex>
                {selectedView === "grid" ? (
                    <ConsignadoBalanceSolicitationResultCards
                      data={documentConsult?.data}
                      selectedIds={selectedIds}
                      setSelectedIds={setSelectedIds}
                      isConsignado={true}
                    />
                  ) : (
                    <ConsignadoBalanceSolicitationResultTable
                      data={documentConsult?.data!}
                      selectedIds={selectedIds}
                      setSelectedIds={setSelectedIds}
                      isConsignado={true}
                    />
                  )}
    
                    <Flex justifyContent="center" mt={5} mb={2} alignItems="center" flexWrap="wrap" gap={2}>
                      <IconButton
                        icon={<ChevronLeftIcon />}
                        onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                        isDisabled={page === 1}
                        aria-label="Página Anterior"
                      />
                      <Text mx={4}>
                        Página {page} de {totalPages}
                      </Text>
                      <IconButton
                        icon={<ChevronRightIcon />}
                        onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
                        isDisabled={page === totalPages}
                        aria-label="Próxima Página"
                      />
                      <Flex alignItems="center" ml={4}>
                        <Text mr={2}>Itens por página:</Text>
                        <Select
                          value={pageSize}
                          onChange={handlePageSizeChange}
                          width="fit-content"
                        >
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                          <option value={50}>50</option>
                        </Select>
                      </Flex>
                    </Flex>
              </>
              )}
            </Box>
          </CardBody>
        </Card>
      </Flex>
        )}

        {activeTab === "processamento" && (
          <ConsignadoProcessingQueueSummary />
        )}
      </Box>
    </Container>
  );
}